import { Box, Divider } from '@wix/design-system';
import classNames from 'classnames';
import { RootStore, withInjectedRootStore } from 'providers';
import * as React from 'react';
import { AcceptedPaymentMethods } from './AcceptedPaymentMethods';
import { AfnicRecommended } from './AfnicRecommended';
import { MoneyBackGuarantee } from './MoneyBackGuarantee';
import s from './PageFooter.scss';
import { SaleDisclaimer } from './SaleDisclaimer';
import { SSLSecurePayment } from './SSLSecurePayment';

export interface PageFooterProps {
  rootStore: RootStore;
  className?: string;
}

const VerticalDivider: React.FC = () => (
  <Box
    align='center'
    verticalAlign='middle'
    marginLeft='SP6'
    marginRight='SP6'
    alignSelf='stretch'
  >
    <Box width='1px' height='30px' backgroundColor='D60' />
  </Box>
);

export const PageFooterAdvancedComp: React.FunctionComponent<
  PageFooterProps
> = ({ children, rootStore, className }) => {
  const { isChangePlan, isFranchPackagePicker, currentStep } =
    rootStore.appStore;

  return (
    <Box
      direction='vertical'
      className={classNames(s.pageFooterContainer, className)}
    >
      <SaleDisclaimer>{children}</SaleDisclaimer>
      <Divider />
      <Box direction='horizontal' verticalAlign='top' padding='36px 0'>
        <Box flex={1}>
          <AcceptedPaymentMethods />
        </Box>
        <VerticalDivider />
        {!isChangePlan && (
          <>
            <Box flex={1}>
              <MoneyBackGuarantee />
            </Box>
            <VerticalDivider />
          </>
        )}
        <Box flex={1}>
          <SSLSecurePayment />
        </Box>
      </Box>
      {isFranchPackagePicker && currentStep === 0 && <AfnicRecommended />}
    </Box>
  );
};

export const PageFooter = withInjectedRootStore(PageFooterAdvancedComp);
